<h1 mat-dialog-title>Reestablecer Contraseña</h1>
<mat-dialog-content>
  <div class="text-red-600 mt-3 mb-3">
    * La contraseña ha sido cambiada por el administrador. Favor reestablecer la contraseña por cuestiones de seguridad.
  </div>
  <form [formGroup]="saveForm">
    <div fxLayout="column">
      <mat-form-field fxFlex appearance="outline">
        <mat-label>Ingrese Contraseña</mat-label>
        <input type="password"
               matInput
               id="password" required autocomplete="new-password"
               formControlName="password" name="password"/>
      </mat-form-field>
      <mat-form-field fxFlex appearance="outline">
        <mat-label>Confirme Contraseña</mat-label>
        <input type="password" id="confirmPassword" matInput autocomplete="new-password"
               formControlName="password_confirmation" name="confirmPassword" required>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="changePassword()" cdkFocusInitial>Guardar</button>
  <button mat-raised-button mat-dialog-close>Cancelar</button>
</mat-dialog-actions>
